import React, { Component } from 'react';

import PageHead from '../components/FichaLogistica/Etiquetado/PageHead';
// import GridSection from '../components/FichaLogistica/Asignaciones/GridSection';

export default class FichaEtiquetado extends Component {
  render() {
    return (
      <div>
        <PageHead />
        <div className='wrapper'>
          <div className='tab-content'>
            <div className='tab-pane active' id='programados'>
              <div className='tableWrapper'>
                  asd
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/FichaEtiquetado.js